import React from 'react';
import PropTypes from 'prop-types';

import NewMilestoneDialog from 'components/milestones/NewMilestoneDialog';
import ToDo from './ToDo';
import styles from 'styles/components/ToDos.module.scss';

const ToDoList = ({ todos, handleUpdateTodo }) => {
  const todosWithSort = todos.map(todo => {
    let sort = 6;

    if (todo.status === 'rejected') {
      // Rejected has priority
      sort = 0;
    } else if (todo.posted_at && new Date() >= new Date(todo.expires_at)) {
      // Time to take down and upload delivery
      sort = 1;
    } else if (
      todo.status === 'pending' &&
      !todo.posted_at &&
      new Date() >= new Date(todo.earliest_start_time)
    ) {
      // Time to post proof screenshot
      sort = 2;
    } else if (todo.posted_at && new Date() <= new Date(todo.expires_at)) {
      // Live time hasn't expired yet. Waiting for takedown
      sort = 3;
    } else if (todo.status === 'awaiting_approval') {
      // Awaiting Approval
      sort = 4;
    } else if (todo.status === 'approved') {
      // Approved
      sort = 5;
    } else if (
      todo.status === 'pending' &&
      !todo.posted_at &&
      new Date() < new Date(todo.earliest_start_time)
    ) {
      // ToDo is not active yet
      sort = 10;
    }

    return { ...todo, sort };
  });

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th style={{ flex: 3, minWidth: 300 }}>ToDo</th>
            <th style={{ flex: 1, minWidth: 150 }}>Amount</th>
            <th style={{ flex: 2, minWidth: 200 }}>Network</th>
            <th style={{ flex: 1, minWidth: 200 }}>Client</th>
            <th style={{ flex: 2, minWidth: 200 }}>Username</th>
          </tr>
        </thead>

        <tbody>
          {todosWithSort
            .sort((a, b) => new Date(a.expires_at) - new Date(b.expires_at))
            .filter(todo => todo.funded && todo.sort < 10)
            .sort((a, b) => a.sort - b.sort)
            .map(todo => (
              <ToDo key={todo.id} todo={todo} />
            ))}
        </tbody>
      </table>

      <NewMilestoneDialog handleUpdateMilestone={handleUpdateTodo} agencyView />
    </div>
  );
};

ToDoList.propTypes = {
  todos: PropTypes.array.isRequired,
  handleUpdateTodo: PropTypes.func,
};

ToDoList.defaultProps = { handleUpdateTodo: () => {} };

export default ToDoList;
